import { CubeContext, useCubeMeta } from "@cubejs-client/react";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
// import HypetBreadcrumbs from "../components/Breadcrumbs";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { Grid } from "@mui/material";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Chip from "@mui/material/Chip";
import DeleteIcon from "@material-ui/icons/Delete";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import AddIcon from "@mui/icons-material/Add";
import {
  Autocomplete,
  CircularProgress,
  Dialog,
  DialogTitle,
  FormControl,
  InputLabel,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Tabs,
  TextField,
  Tooltip,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { tableCellClasses } from "@mui/material/TableCell";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { differenceInDays } from "date-fns";
import saveAs from "file-saver";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import moment from "moment";
import momentTz from "moment-timezone";
import React, {
  useCallback,
  useContext,
  useEffect,
  useState,
  useRef,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { CustomProvider, DateRangePicker } from "rsuite";
import * as XLSX from "xlsx";
import { AppContext } from "../../../../App";
import axios from "../../../../Utils/AxiosConfig/axiosConfig";
import useWindowReSize from "../../../../Utils/cutsomHooks/windowReSize";
import { loadSnackbar } from "../../../../Utils/util";
import { Asset_Usecase } from "../../../../models/Types_Interfaces";
import { ReactComponent as ChartIcon } from "./icons/chart-view-icon.svg";
import { ReactComponent as DocumentIcon } from "./icons/document-icon.svg";
import { ReactComponent as DownIcon } from "./icons/down-icon.svg";
import { ReactComponent as ListIcon } from "./icons/list-view-icon.svg";
import { ReactComponent as BookMarkIcon } from "./icons/bookmark-icon.svg";
import { ReactComponent as TrendAnalysisChartIcon } from "./icons/TrendAnalysisIcon.svg";
import fetchAndTrackCubeQuery from "../../../../Utils/UtilFunctions/trackedCubeQuery";
import { useStyles } from "./utils/TroubleShootModuleStyles";
import CustomTabPanel from "./Components2/CustomTabPanel";
import DeleteTemplate from "./DeleteTemplate";
import { generateTroubleShootPDF } from "./GenerateTroubleShootPDF";
import TrendAnalysisChart from "./TrendAnalysisChart";
import CustomOption from "./Components2/CustomOption";
import MultiValueLabel from "./Components2/CustomMultiValueLabel";
import { dateFormatter, getTagsForTagsFilter } from "./utils";
import { env } from "../../../../env";
import useFetchAssetData from "./Hooks/fetchAssetsHook";
import SubHeader from "./components/SubHeader";
import ContentSubHeader from "./components/ContentSubHeader";
const baseURL = env?.microservice_assetsmgt;

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    fontSize: 11.5,
    fontWeight: 600,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 11.5,
  },
}));

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const cardTitle: any = {
  "0": "Table View Analysis",
  "1": "Single ChartView Analysis",
  "2": "Detailed Trend Analysis",
};

const cardSubTitle: any = {
  "0": "Key Insights from Tabular Data",
  "1": "Understanding Data through One Visualization",
  "2": "Unveiling Insights through Trend Patterns",
};

const maxTagsSelectionLimit = 10;
const MODULE = "UTILITIES_Troubleshoot";

function TroubleShoot() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const classes = useStyles();
  const metaCubeNames = useCubeMeta();
  const { cubejsApi } = useContext(CubeContext);
  const [width] = useWindowReSize();
  const appContextProps: any = useContext(AppContext); //consuming context created in App.tsx
  const chartRef = useRef<any>(null);
  const containerRef = useRef<any>(null);
  const plantsList = useSelector((state: any) => state.plantsList);
  const levelsList = useSelector((state: any) => state.levelsList);
  const usersList = useSelector((state: any) => state.usersList);
  const usecaseList = useSelector((state: any) => state.usecaseList);
  const assetsList = useSelector((state: any) => state.assetsList);
  // const defaultPlantCode = appContextProps.selectedPlantForCube || "ALA";
  const defaultPlantCode = "SL2";
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedPlant, setSelectedPlant] = useState<any>(null);
  const [currentUseCase, setCurrentUseCase] = useState<any>(null);
  const [selectedInterval, setSelectedInterval] = useState<any>("default");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [availablePlants, setAvailablePlants] = useState<any>([]); //fetching and storing current usecase details through url
  const [tabValue, setTabValue] = useState(0);
  const [selectedTemplateName, setSelectedTemplateName] = useState<any>(null);
  const [selectedTemplateObj, setSelectedTemplateObj] = useState<any>(null);
  const [selectedTemplateModified, setSelectedTemplateModified] =
    useState(false);
  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
  const [filteredParentAssets, setFilteredParentAssets] = useState<any>([]);
  const [filteredAssets, setFilteredAssets] = useState<any>([]);
  const [templateList, setTemplateList] = useState<any>([]);
  const [originalTemplateList, setOriginalTemplateList] = useState<any>(
    usersList.currentUser.save_template
  );
  const [disable, setDisable] = useState<any>(true);
  const [dateRangeValue, setDateRangeValue] = useState<any>([]);
  const [dataRanges, setDataRanges] = useState<any>([]);
  const [saveValue, setSaveValue] = useState<any>(null);
  const [open, setOpen] = useState(false);
  const [chartOptions2, setChartOptions2] = useState<any>([]);
  const [highestGroup, setHighestGroup] = useState<any>([]);
  const [maxGroupIdx, setMaxGroupIdx] = useState<number>(0);
  const [tagsCube, setTagsCube] = useState<any>(null); //state to store tags cube
  const [tagsArray1, setTagsArray1] = useState<any>([]);
  const [filterMessage, setFilterMessage] = useState<any>({
    useCaseId: "",
    plantId: "",
  });
  const [templateName, setTemplateName] = useState<any>("");
  const [parentAssetOptions, setParentAssetOptions] = useState<any>([]);
  const [assetOptions, setAssetOptions] = useState<any>([]);
  const [grandSubAssetsOptions, setGrandSubAssetsOptions] = useState<any>([]);
  const [grandSubAssetsOptionsCopy, setGrandSubAssetsOptionsCopy] =
    useState<any>([]);
  const [tagOptions, setTagOptions] = useState<any[]>([]);
  const [tagOptionsCopy, setTagOptionsCopy] = useState<any[]>([]);
  const [tagFilterOptions, setTagFilterOptions] = useState<any[]>([]);
  const [tagFilterOptionsCopy, setTagFilterOptionsCopy] = useState<any[]>([]);
  const [selectedParentAssets, setSelectedParentAssets] = useState<any>([]);
  const [selectedParentAssetsCopy, setSelectedParentAssetsCopy] =
    useState<string>("");
  const [selectedAssets, setSelectedAssets] = useState<any>([]); // Initialize with the default value
  const [selectedAssetsCopy, setSelectedAssetsCopy] = useState<string>("");
  const [selectedGrandSubAssets, setSelectedGrandSubAssets] = useState<any>([]);
  const [selectedTagValue, setSelectedTagValue] = useState<any>([]); // Initialize with the default value
  const [selectedFilterTagValue, setSelectedFilterTagValue] = useState<any>([]);
  const [tagsOnlyFilterInput, setTagsOnlyFilterInput] = useState<any>("");
  const [tagsOnlyFilterOptions, setTagsOnlyFilterOptions] =
    useState<any>(tagFilterOptions);
  const [assetsForTagsFilter, setAssetsForTagsFilter] = useState<any>([]);
  const [cubeResponse, setCubeResponse] = useState<any>([]);
  const [cubeResponseTagLength, setCubeResponseTagLength] = useState<any>(0);
  const [disableExport, setdisableExport] = useState<any>(true);
  const [groupResponse, setgroupResponse] = useState<any>([]);
  const exportHide = false;
  const [chartOptionsTemp, setChartOptionsTemp] = useState<any>({});
  const [isPrint, setIsPrint] = useState<any>(false);
  const [selectedTagValueCountMismatch] = useState<any>({
    flag: false,
    invalid_tag: [],
  });
  const [assetIds, setAssetIds] = useState<string[]>([]);
  const [queryKeyString, setQueryKeyString] = useState<string>("");
  const [customizedColumns, setCustomizedColumns] = useState<any>([]);
  const [rowsToShow, setRowsToShow] = useState<any>(highestGroup);
  const [columns, setColumns] = useState(Object.keys(groupResponse));
  const [page, setPage] = useState(0); // Current page
  const [rowsPerPage, setRowsPerPage] = useState(10); // Rows per page
  const [assetData, setAssetData] = useState<any>(null);
  const [anchorElExport, setAnchorElExport] = useState<null | HTMLElement>(
    null
  );
  const [isFilterByTags, setIsFilterByTags] = useState<boolean>(false);
  const openExport = Boolean(anchorElExport);
  const levelTypes = assetsList.assets;
  const labelColors = ["#ed80e9", "#ffee8c", "#ffb27f", "#adebb3", "#ffc5d3"];
  const plantTimeZone = selectedPlant?.plant_timezone;

  // Render the table rows based on the current page and rows per page
  // const rowsToShow = highestGroup?.slice(startIndex, endIndex);
  const colors = [
    "#FCBA03",
    "#1DAC56",
    "#7a7fff",
    "#7FFF30",
    "#E06060",
    "#46FFD4",
    "#FFCC33",
    "#FF0000",
    "#FFFFFF",
    "#18A0FB",
    "#980000",
    "#000000",
    "#7B4736",
    "#FE13E6",
    "#FFFF00",
  ];

  const handleMetricOpenDialog = () => {
    setDialogOpen(true);
  };

  const handleMetricCloseDialog = () => {
    setDialogOpen(false);
  };
  //fatching tags based on base tag
  const getTags: any = async () => {
    // tagsQuery1 for storing tags
    const tagsQuery1: any = {
      dimensions: [`${tagsCube?.name}.tagName`],
      filters: [
        {
          member: `${tagsCube?.name}.tagName`,
          operator: "contains",
          values: [].concat(
            selectedGrandSubAssets?.map((item: any) => item.tag)
          ),
        },
        {
          member: `${tagsCube?.name}.tagName`,
          operator: "contains",
          values: [selectedPlant?.plant_name.replace(/ /g, "")],
        },
      ],
    };
    const { data: fetchedTagsResult } = await fetchAndTrackCubeQuery(
      cubejsApi,
      tagsQuery1
    );
    setTagsArray1(
      fetchedTagsResult
        ?.map((dataArray: any) => {
          return dataArray.map((datapoint: any) => {
            const key: any = Object.keys(datapoint).find((key: any) => {
              return key.includes("tagName");
            });
            return datapoint[key];
          });
        })
        .flat()
    );
  };

  const isTemplateModified = (items: any, type: string) => {
    if (selectedTemplateName) {
      const savedTemplate = JSON.stringify(selectedTemplateObj);

      const modifiedTemplate = {
        name: selectedTemplateName.name,
        subAssets:
          type === "subAssets"
            ? items.map((item: any) => item.value)
            : selectedAssets.map((item: any) => item.value),
        subAssets2:
          type === "subAssets2"
            ? items.map((item: any) => item.value)
            : selectedGrandSubAssets.map((item: any) => item.value),
        tags:
          type === "tags"
            ? items.map((item: any) => item.value)
            : selectedTagValue.map((item: any) => item.key),
        filterTags:
          type === "filterTags"
            ? items.map((item: any) => item.value)
            : selectedFilterTagValue.map((item: any) => item.key),
      };

      setSelectedTemplateModified(
        savedTemplate !== JSON.stringify(modifiedTemplate)
      );
    }
  };
  const handleTemplateSelect = (item: any) => {
    if (item?.plant_id && item.plant_id !== selectedPlant._id) {
      const plant = availablePlants.filter(
        (plant: any) => plant._id === item.plant_id
      )[0];
      setSelectedPlant(plant);
      appContextProps.setSelectedPlantForCube(plant.plant_code);
      setTimeout(() => {
        templateSelectedCTA(item);
      }, 1000);
    } else {
      templateSelectedCTA(item);
    }
  };

  const templateSelectedCTA = (item: any, isTemplate = true) => {
    const parentAssets = item.parentAssets;
    const subAssets = item.subAssets;
    const subAssets2 = item.subAssets2;
    const tags = item?.tags?.map((tag: any) => {
      return {
        label: tag?.label,
        value: tag?.value,
        color: tag?.color,
        key: tag?.key,
      };
    });

    const filterTags = item?.filterTags?.map((tag: any) => {
      return {
        label: tag?.label,
        value: tag?.value,
        color: tag?.color,
        key: tag?.key,
      };
    });

    if (isTemplate) {
      setSelectedTemplateName({ name: item.name.trim() });
      setSelectedTemplateObj(item);
    }
    setSelectedTagValue(tags);
    setSelectedFilterTagValue(filterTags || []);
    setSelectedParentAssets(parentAssets);
    setSelectedAssets(subAssets); // check
    setSelectedGrandSubAssets(subAssets2);
  };

  const deleteTemplateCTA = (isDelete: boolean) => {
    if (isDelete) {
      const index1 = originalTemplateList.findIndex(
        (tem: any) =>
          tem.name === selectedTemplateName.name && tem.type === MODULE
      );

      originalTemplateList.splice(index1, 1);
      setOriginalTemplateList(originalTemplateList);
      saveTemplate("delete");
      setSelectedTemplateName(null);
      setSelectedTemplateObj({});
      setSelectedParentAssets([]);
      setSelectedAssets([]);
      setSelectedGrandSubAssets([]);
      setSelectedTagValue([]);
      setSelectedFilterTagValue([]);
      setSelectedTemplateModified(false);
    }
  };

  const tagSelected = (item: any) => {
    const currentTagsLength = item.length;
    if (currentTagsLength > maxTagsSelectionLimit) {
      dispatch({
        type: "LOAD_SNACKBAR",
        payload: {
          message: `Tags limit exceeded: A Maximum of ${maxTagsSelectionLimit} tags can be viewed.`,
          type: "warning",
          open: true,
        },
      });
      return;
    }
    setSelectedTagValue(item);
    //Reset customized column order when adding new tag.
    setCustomizedColumns([]);
    //Call Modify check
    isTemplateModified(item, "tags");
  };

  const handleParentAssetSelected = (item: any) => {
    if (item.length === 0) {
      setSelectedAssets([]);
      setSelectedGrandSubAssets([]);
      setSelectedTagValue([]);
    }
    setSelectedParentAssets(item);
    isTemplateModified(item, "parent");
  };

  const assetSelected = (item: any) => {
    if (item.length === 0) {
      setSelectedGrandSubAssets([]);
      setSelectedTagValue([]);
    }
    setSelectedAssets(item);
    //Call Modify
    isTemplateModified(item, "subAssets");
  };

  const handleGrandSubAssets = (item: any) => {
    if (item.length === 0) {
      setSelectedTagValue([]);
    }
    setSelectedGrandSubAssets(item);
    isTemplateModified(item, "subAssets2");
  };
  const handleSelectedFilterTags = (event: any, value: any) => {
    const selectedOptions = value.map((tag: string) => {
      return { label: tag, value: tag, key: tag };
    });
    setSelectedFilterTagValue(selectedOptions);
    isTemplateModified(selectedOptions, "filterTags");
  };

  const updateTemplateCTA = () => {
    saveTemplate("update");
  };

  const saveTemplate = (action?: string) => {
    try {
      let parentAssets: Array<string> = [];
      let subAssets: Array<string> = [];
      let subAssets2: Array<string> = [];
      let tags: Array<string> = [];
      let filterTags: Array<string> = [];
      parentAssets = selectedParentAssets;
      subAssets = selectedAssets;
      subAssets2 = selectedGrandSubAssets;
      tags = selectedTagValue;
      filterTags = selectedFilterTagValue;
      const tableColumns = columns;
      if (tableColumns.length > 0) {
        const orderModifiedColumns: Array<string> = [];
        tableColumns.forEach((key: string) => {
          const columnKey = `${key.split("_")[1]}_${key.split("_")[2]}`;
          tags.map((item: any) => {
            if (item?.key?.includes(columnKey)) {
              orderModifiedColumns.push(item);
            }
          });
        });
        tags = [...new Set(orderModifiedColumns)];
      }

      if (tableColumns.length > 0) {
        const orderModifiedColumns: Array<string> = [];
        tableColumns.forEach((key: string) => {
          const columnKey = `${key.split("_")[1]}_${key.split("_")[2]}`;
          filterTags.map((item: any) => {
            if (item?.key?.includes(columnKey)) {
              orderModifiedColumns.push(item);
            }
          });
        });
        filterTags = [...new Set(orderModifiedColumns)];
      }

      // templateFilter["name"] = templateName;
      // setTemplate(templateFilter);
      let save_template: any;
      if (action === "save") {
        if (templateName.trim().length) {
          const template = {
            name: templateName.trim(),
            parentAssets,
            subAssets,
            subAssets2,
            tags,
            filterTags,
            plant_id: selectedPlant._id,
            type: MODULE,
          };

          if (originalTemplateList === undefined) {
            save_template = [template];
          } else {
            save_template = [...originalTemplateList, template];
          }
        }
      } else if (action === "update") {
        const index = originalTemplateList.findIndex(
          (item: any) =>
            item.type === MODULE && item.name === selectedTemplateName?.name
        );
        if (index > -1) {
          originalTemplateList[index].parentAssets = [...parentAssets];
          originalTemplateList[index].subAssets = [...subAssets];
          originalTemplateList[index].subAssets2 = [...subAssets2];
          originalTemplateList[index].tags = [...tags];
          originalTemplateList[index].filterTags = [...filterTags];
          save_template = [...originalTemplateList];
        }
      } else if (action === "delete") {
        save_template = originalTemplateList.length
          ? [...originalTemplateList]
          : [];
      }

      const payload = {
        _id: usersList.currentUser._id,
        save_template,
      };

      axios
        .put(`users/saveTemplate`, payload)
        .then((res: any) => {
          setSaveValue(res);
          dispatch({
            type: "LOAD_SNACKBAR",
            payload: {
              message:
                action === "delete"
                  ? "Template deleted successfully"
                  : action === "save"
                  ? "Template Saved successfully"
                  : "Template Updated successfully",
              type: "success",
              open: true,
            },
          });
          setOpen(false);
          switch (action) {
            case "save":
              setSelectedTemplateModified(false);
              setSelectedTemplateName({ name: templateName.trim() });
              setSelectedTemplateObj(save_template);
              break;
            case "update":
              setSelectedTemplateModified(false);
              break;
            case "delete":
              resetSelectedAssetTagsTemplatesCTA();
              break;

            default:
              break;
          }
        })
        .catch((error: any) => {
          dispatch({
            type: "LOAD_SNACKBAR",
            payload: {
              message: "Something went wrong!",
              type: "error",
              open: true,
            },
          });
        });
    } catch (error: any) {
      dispatch({
        type: "LOAD_SNACKBAR",
        payload: {
          message: "Something went wrong!",
          type: "error",
          open: true,
        },
      });
      setOpen(false);
    }
  };

  const extractAssetOptions = (data: any): any => {
    const assetOptions: any = data?.map((item: any, index: any) => ({
      label: item?.asset_alias || "",
      value: item?.asset_alias || "",
      key: item?.asset_alias || "",
      id: item?._id || "",
      color: labelColors[index],
      tag: "",
    }));
    return assetOptions;
  };

  const extractSubAssetOptions = (data: any) => {
    const assetOptions = data.map((item: any) => {
      const color = selectedParentAssets.find(
        (opt: any) => opt?.id === item?.parent_asset
      )?.color;
      const prefix = item?.asset_alias;
      return {
        label: item?.asset_alias || "",
        value: item?.asset_alias || "",
        key: item?.asset_alias || "",
        id: item?._id || "",
        color,
        prefix,
        tag: "",
      };
    });
    return assetOptions;
  };

  const extractGrandChildOptions = (data: any) => {
    const optionsArray: any = [];
    data?.forEach((item: any) => {
      const assetObj = selectedAssets.find(
        (asset: any) => asset?.id === item?.parent_asset
      );
      const eleName = `${assetObj?.prefix} - ${item?.asset_alias}`;
      optionsArray.push({
        label: eleName,
        value: eleName,
        key: eleName,
        parent: item?.parent_asset,
        tag: item?.devices.length
          ? item?.devices?.find(
              (device: any) => device?.usecase === currentUseCase?._id
            )?.tag
          : "",
        child: [],
        color: assetObj?.color,
        prefix: item?.asset_alias,
        id: item?._id,
      });
    });
    return optionsArray;
  };

  const extractTagOptions = (data: any) => {
    let tagOptions: any = [];
    tagOptions = data.map((item: any) => {
      if (item) {
        const result: any = [];
        const description = item?.split("_");
        selectedGrandSubAssets.forEach((assetOpt: any) => {
          if (item.includes(assetOpt?.tag)) {
            result.push({
              label: `${assetOpt?.prefix} - ${description?.at(
                -4
              )}_${description?.at(-3)}_${description?.at(
                -2
              )}_${description?.at(-1)}`,
              value: `${assetOpt?.prefix} - ${description?.at(
                -4
              )}_${description?.at(-3)}_${description?.at(
                -2
              )}_${description?.at(-1)}`,
              color: assetOpt?.color,
              key: item || "",
            });
          }
        });
        return result;
      }
    });
    return tagOptions.flat();
  };
  const handleFilterInputChange = useCallback(
    (event: any) => {
      const inputValue = event.target.value || tagsOnlyFilterInput;
      setTagsOnlyFilterInput(inputValue);
      const filtered = tagFilterOptions
        .filter((option: any) =>
          option.key.toLowerCase().includes(inputValue.toLowerCase())
        )
        .map((option: any) => option.key);
      setTagsOnlyFilterOptions(filtered);
    },
    [tagFilterOptions]
  );

  const getUserAccess = async () => {
    let res = null;
    res = await axios.get(`users/${usersList.currentUser._id}`);
    const result =
      res.data.save_template === undefined ? [] : res.data.save_template;
    if (selectedPlant?._id) {
      setOriginalTemplateList(result);
      setTemplateList(
        result.filter(
          (current: any) =>
            (current.type === undefined || current.type === MODULE) &&
            current.plant_id === selectedPlant?._id
        )
      );
    }
  };

  const getUniqueData = (
    type: string,
    copyData: any,
    selectedData: any,
    currentUseCaseId: string
  ) => {
    let uniqueOptions: any = [];
    switch (type) {
      case "parent_asset":
        {
          const extractedAssetOptions = extractAssetOptions(copyData);
          uniqueOptions = extractedAssetOptions.filter(
            (asset: any) =>
              !selectedData.some((item: any) => item?.key === asset?.key)
          );
        }
        break;
      case "sub_asset":
        {
          const extractedAssetOptions = extractSubAssetOptions(copyData);
          uniqueOptions = extractedAssetOptions.filter(
            (asset: any) =>
              !selectedData.some((item: any) => item?.key === asset?.key)
          );
        }
        break;
      case "sub_asset_1":
        {
          uniqueOptions = copyData?.filter(
            (asset: any) =>
              !selectedData.some(
                (item: any) =>
                  item?.key === asset?.key && item?.id === asset?.id
              )
          );
        }
        break;
      case "tags":
      case "filter_tags":
        {
          uniqueOptions = copyData.filter(
            (asset: any) =>
              !selectedData.some((item: any) => item?.key === asset?.key)
          );
        }
        break;
    }
    return uniqueOptions;
  };

  const handleClickOpen = () => {
    setTemplateName("");
    setOpen(true);
  };

  const handleClickExport = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (tabValue === 1) {
      // setIsPrint(true);
    }
    setAnchorElExport(event.currentTarget);
  };
  const handleCloseExport = () => {
    setAnchorElExport(null);
  };

  const exportPDF = async () => {
    const assetNames: string[] = [];
    const tagNames: string[] = [];
    const dateRangeStr = `${moment(dateRangeValue[0]).format(
      "MM-DD-YY - HH:mm"
    )} ${moment.tz(plantTimeZone).format("z")} / ${moment(
      dateRangeValue[1]
    ).format("MM-DD-YY - HH:mm")} ${moment.tz(plantTimeZone).format("z")}`;
    selectedAssets.map((obj: any) => assetNames.push(obj.value));
    selectedTagValue.map((obj: any) => tagNames.push(obj.key));
    selectedFilterTagValue.map((obj: any) => tagNames.push(obj.key));

    handleCloseExport();
    await generateTroubleShootPDF(
      selectedPlant?.plant_name,
      "Utilities- Troubleshooting Module",
      assetNames.join(", "),
      tagNames,
      dateRangeStr,
      tabValue
    ).finally(() => handleCloseExport());
  };

  const getGroupData = async () => {
    // debugger;
    const data = cubeResponse;
    return data.reduce((acc: any, obj: any) => {
      const key = obj["tagName"];
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(obj);
      return acc;
    }, {});
  };

  const findHighestValueInGroup = (group: any) => {
    const validTagValues: any = [];
    Object.keys(group).map((item: any) => {
      if (!selectedTagValueCountMismatch?.invalid_tag?.includes(item)) {
        validTagValues.push(group[item]);
      }
    });

    const highData = validTagValues.reduce((acc: any, arr: any) => {
      if (Array.isArray(arr) && arr.length > acc.length) {
        return arr;
      }
      return acc;
    }, []);
    return highData;
  };

  // Find Max Group Index
  const findMaxGroupIdx = (data: any) => {
    const validTagValues: any = [];
    Object.keys(data).map((item: any) => {
      if (!selectedTagValueCountMismatch?.invalid_tag?.includes(item)) {
        validTagValues.push(data[item]);
      }
    });
    return validTagValues?.reduce(
      (maxIdx: number, currentValue: any, currentIndex: number) => {
        if (
          Array.isArray(currentValue) &&
          currentValue.length > validTagValues[maxIdx]?.length
        ) {
          return currentIndex;
        } else {
          return maxIdx;
        }
      },
      0
    );
  };

  // fetch cube response based on selected tags in dropdown
  const getData = async () => {
    const name = appContextProps.selectedPlantForCube;
    const timestamp: any = {
      default: `${name}FiveMinAgg`,
      minute: `${name}FiveMinAgg`,
      hour: `${name}HourlyAgg`,
      day: `${name}DailyAgg`,
    };

    const tagData1 = selectedTagValue.map((ele: any) => {
      return ele.key;
    });

    const tagData2 = selectedFilterTagValue.map((ele: any) => {
      return ele.key;
    });
    const tagData = [...tagData1, ...tagData2];
    setIsLoading(true);
    setgroupResponse({});
    if (tagData.length > 0) {
      const fetchedData = tagData
        .map((tag: any) => {
          return createQueryUsingTag(tag);
        })
        .map(async (query: any) => {
          return await getDataFromCube(query).then((res: any) => {
            return res;
          });
        });

      Promise.all(fetchedData)
        .then(async function (resolvedArray: any) {
          setCubeResponseTagLength(resolvedArray.length);
          // debugger;
          // Handle the resolved array here
          setCubeResponse(
            resolvedArray.flat().map((item: any) => {
              const tag_name =
                item[`${timestamp[selectedInterval]}.tagName`].split("_");
              return {
                tagName: `${tag_name[tag_name.length - 4]}_${tag_name[
                  tag_name.length - 3
                ].slice(3)}_${tag_name[tag_name.length - 2]}`,
                key: item[`${timestamp[selectedInterval]}.tagName`],
                value: Number(
                  item[
                    `${timestamp[selectedInterval]}.${
                      selectedInterval === "day" || selectedInterval === "hour"
                        ? "avgValue"
                        : "lastValue"
                    }`
                  ]
                ),
                date: item[`${timestamp[selectedInterval]}.timestamp`],
              };
            })
          );

          // setCubeResponseForRecipe(
          //   resolvedArray.flat().map((item: any) => {
          //     return {
          //       key: item[`${timestamp[selectedInterval]}.tagName`],
          //       value: item[`${timestamp[selectedInterval]}.description`],
          //     };
          //   })
          // );
        })
        .then(() => {
          setIsLoading(false);
        })
        .catch(() => dispatch(loadSnackbar()))
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      setIsLoading(false);
      setCubeResponse([]);
      setgroupResponse({});
    }
  };

  const s2ab = (s: any) => {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
    return buf;
  };

  const exportCSV = async () => {
    try {
      const cubeData = Object.keys(groupResponse).map((key: string) => ({
        tag: key,
        data: groupResponse[key].map((e: any) => e.value),
      }));
      const date: any = [];
      const time: any = [];
      highestGroup.map((item: any) => {
        date.push(moment(item.date).format("MMM DD, YYYY"));
        time.push(moment(item.date).format("hh:mm A z"));
      });
      const csvData = [
        { tag: "Date", data: date },
        { tag: "Time", data: time },
        ...cubeData,
      ];
      const wb = XLSX.utils.book_new();
      const rowPerSheet = 1000000;
      const maxLength = Math.max(...csvData.map((item) => item.data.length));
      const numberOfSheets = Math.ceil(maxLength / rowPerSheet);
      const columnName: any = csvData.map((item) => item.tag);

      for (let sheetIndex = 0; sheetIndex < numberOfSheets; sheetIndex++) {
        const wsData = [columnName];

        for (let i = 0; i < rowPerSheet; i++) {
          const dataIndex = sheetIndex * rowPerSheet + i;
          if (dataIndex < maxLength) {
            const row = csvData.map((item) => item.data[dataIndex]);
            wsData.push(row);
          }
        }

        const ws: any = XLSX.utils.aoa_to_sheet(wsData);

        const boldCell = { font: { bold: true } };
        const columnwidth = [];

        for (let j = 0; j < columnName.length; j++) {
          const cellAddress = XLSX.utils.encode_cell({ r: 0, c: j });
          ws[cellAddress] = { v: columnName[j], s: boldCell };

          const columnNameLength = columnName[j].length;
          const width = columnNameLength > 10 ? columnNameLength - 3 : 13;
          columnwidth.push({ wch: width });
        }
        ws["!cols"] = columnwidth;
        XLSX.utils.book_append_sheet(wb, ws, `Sheet${sheetIndex + 1}`);
      }

      const wbout = XLSX.write(wb, { bookType: "xlsx", type: "binary" });
      const blob = new Blob([s2ab(wbout)], {
        type: "application/octet-sream",
      });
      saveAs(
        blob,
        `Utilities - Troubleshooting Module - ${selectedPlant?.plant_name}.xlsx`
      );
      handleCloseExport();
    } catch (error) {
      dispatch(loadSnackbar());
    }
  };

  const getDataFromCube = async (query: any) => {
    if (query.filters[0].values.length !== 0) {
      const { data: fetchedData } = await fetchAndTrackCubeQuery(
        cubejsApi,
        query
      );
      return fetchedData.flat();
    } else {
      return null;
    }
  };

  const convertTimezoneCustom = (
    timestamp: any,
    sourceTimezone: any,
    targetTimezone: any,
    format?: any
  ) => {
    const sourceTime = momentTz.tz(timestamp, sourceTimezone);
    const targetTime = sourceTime.tz(targetTimezone);
    return targetTime.format(format || "YYYY-MM-DDTHH:mm:ss.SSS");
  };

  const createQueryUsingTag = (tag: any) => {
    const name = appContextProps.selectedPlantForCube || "RIA";
    const timestamp: any = {
      default: `${name}FiveMinAgg`,
      minute: `${name}FiveMinAgg`,
      hour: `${name}HourlyAgg`,
      day: `${name}DailyAgg`,
    };
    const valuesLast =
      selectedInterval === "hour" || selectedInterval === "day"
        ? "avgValue"
        : "lastValue";
    const dataQuery: any = {
      measures: [`${timestamp[selectedInterval]}.${valuesLast}`],
      timeDimensions: [
        {
          dimension: `${timestamp[selectedInterval]}.timestamp`,
          granularity:
            selectedInterval === "default" ? "minute" : selectedInterval,
          dateRange: [
            convertTimezoneCustom(
              moment(dateRangeValue?.[0]).format("YYYY-MM-DDTHH:mm:ss"),
              plantTimeZone,
              "America/Los_Angeles",
              "YYYY-MM-DDTHH:mm:ss.000"
            ),
            convertTimezoneCustom(
              moment(dateRangeValue?.[1]).format("YYYY-MM-DDTHH:mm:ss"),
              plantTimeZone,
              "America/Los_Angeles",
              "YYYY-MM-DDTHH:mm:ss.000"
            ),
          ],
        },
      ],
      order: [[`${timestamp[selectedInterval]}.timestamp`, "desc"]],
      filters: [
        {
          member: `${timestamp[selectedInterval]}.tagName`,
          operator: "equals",
          values: [tag],
        },
      ],
      dimensions: [
        `${timestamp[selectedInterval]}.description`,
        `${timestamp[selectedInterval]}.deviceName`,
        `${timestamp[selectedInterval]}.tagName`,
      ],
      limit: 50000,
      timezone: "America/Los_Angeles",
    };
    return dataQuery;
  };

  const handleDateChange = (newValue: any) => {
    setDateRangeValue(newValue);
    if (newValue.length === 2) {
      const startDate = newValue[0];
      const endDate = newValue[1];
      const daysDifference = differenceInDays(endDate, startDate);
      let interval = "default";
      if (tabValue === 2) {
        if (daysDifference <= 1) {
          interval = "minute";
        } else if (daysDifference > 1 && daysDifference <= 14) {
          interval = "hour";
        } else {
          interval = "day";
        }
      } else {
        if (daysDifference <= 14) {
          interval = "minute";
        } else if (daysDifference <= 90) {
          interval = "hour";
        } else {
          interval = "day";
        }
      }

      if (
        (tabValue !== 2 && interval !== selectedInterval) ||
        (tabValue === 2 && interval !== selectedInterval)
      ) {
        setSelectedInterval(interval);
      }
    }
  };

  const handleTemplateName = (event: any) => {
    const name = event.target.value;
    if (
      templateList.some(
        (item: any) => item.name.toLowerCase() === name.toLowerCase().trim()
      ) ||
      name.length === 0
    ) {
      setDisable(true);
    } else {
      setDisable(false);
    }
    setTemplateName(name);
  };

  const validateTemplateName = (action: string) => {
    const name = templateName.trim();
    if (name.length) {
      setTemplateName(name);
      saveTemplate(action);
    } else {
      setTemplateName("");
      setDisable(true);
    }
  };

  // Function to handle page changes
  const handlePageChange = (event: any, newPage: any) => {
    setPage(newPage);
  };

  // Function to handle rows per page changes
  const handleLimitChange = (event: any) => {
    setRowsPerPage(+event.target.value);
    setPage(0); // Reset page when rows per page changes
  };

  const handleDragOver = (e: any) => {
    setSelectedTemplateModified(true);
    e.preventDefault();
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setColumns(customizedColumns);
    setTabValue(newValue);
  };

  const handleDrop = (e: any, targetIndex: number) => {
    e.preventDefault();
    const startIndex = Number(e.dataTransfer.getData("index"));
    const newColumns = [...columns];
    const [draggedColumn] = newColumns.splice(startIndex, 1);
    newColumns.splice(targetIndex, 0, draggedColumn);
    setCustomizedColumns(newColumns);
    setColumns(newColumns);

    const updatedGroupResponse: any = {};
    newColumns.forEach((column) => {
      updatedGroupResponse[column] = groupResponse[column];
    });
    setgroupResponse(updatedGroupResponse);
  };

  const resetSelectedAssetTagsTemplatesCTA = () => {
    setSelectedTemplateModified(false);
    setSelectedTemplateName(null);
    setSelectedTemplateObj({});
    setSelectedParentAssets([]);
    setSelectedAssets([]);
    setSelectedGrandSubAssets([]);
    setSelectedTagValue([]);
  };

  const handleDataRanges = () => {
    setDataRanges([
      {
        label: "Last 24 hours",
        value: [
          new Date(
            momentTz()
              .subtract(24, "hours")
              .tz(plantTimeZone)
              ?.format("YYYY-MM-DDTHH:mm:ss.SSS")
          ),
          new Date(
            momentTz().tz(plantTimeZone)?.format("YYYY-MM-DDTHH:mm:ss.SSS")
          ),
        ],
      },
      {
        label: "Today",
        value: [
          new Date(
            momentTz()
              .tz(plantTimeZone)
              ?.startOf("day")
              ?.format("YYYY-MM-DDTHH:mm:ss.SSS")
          ),
          new Date(
            momentTz()
              .tz(plantTimeZone)
              ?.endOf("day")
              ?.format("YYYY-MM-DDTHH:mm:ss.SSS")
          ),
        ],
      },
      {
        label: "Yesterday",
        value: [
          new Date(
            momentTz()
              .subtract(1, "day")
              .tz(plantTimeZone)
              ?.startOf("day")
              ?.format("YYYY-MM-DDTHH:mm:ss.SSS")
          ),
          new Date(
            momentTz()
              .subtract(1, "day")
              .tz(plantTimeZone)
              ?.endOf("day")
              ?.format("YYYY-MM-DDTHH:mm:ss.SSS")
          ),
        ],
      },
      {
        label: "Last 7 days",
        value: [
          new Date(
            momentTz()
              .subtract(6, "days")
              .tz(plantTimeZone)
              ?.startOf("day")
              ?.format("YYYY-MM-DDTHH:mm:ss.SSS")
          ),
          new Date(
            momentTz()
              .tz(plantTimeZone)
              ?.endOf("day")
              ?.format("YYYY-MM-DDTHH:mm:ss.SSS")
          ),
        ],
      },
    ]);
  };

  const handleDragStart = (e: any, index: any) => {
    e.dataTransfer.setData("index", index);
  };

  const setGraphViewWidth = () => {
    if (containerRef.current) {
      const timer = setTimeout(() => {
        chartRef?.current?.chart?.setSize(containerRef.current?.clientWidth);
        return () => {
          clearTimeout(timer);
        };
      }, 500);
    }
  };

  // const { data: assetData, error } = useFetchAssetData(
  //   `${baseURL}assets`,
  //   queryKey,
  //   queryParams
  // );

  useEffect(() => {
    if (assetIds.length && selectedPlant) {
    }
  }, [assetIds]);

  useEffect(() => {
    getUserAccess();
  }, [saveValue, selectedPlant]);

  // parent asset - get unique options
  useEffect(() => {
    const parentColors = selectedParentAssets.map((asset: any) => asset?.color);
    setSelectedAssets(
      selectedAssets.filter((asset: any) => parentColors.includes(asset?.color))
    );
    if (filteredParentAssets.length) {
      setParentAssetOptions(
        getUniqueData(
          "parent_asset",
          filteredParentAssets,
          selectedParentAssets,
          currentUseCase?._id
        )
      );
    }
  }, [filteredParentAssets, selectedParentAssets]);

  // sub asset - get unique options
  useEffect(() => {
    if (filteredAssets?.length) {
      setAssetOptions(
        getUniqueData(
          "sub_asset",
          filteredAssets,
          selectedAssets,
          currentUseCase?._id
        )
      );
    }
  }, [filteredAssets, selectedAssets]);
  // sub asset 2 - get unique options
  useEffect(() => {
    // remove child elements
    if (selectedAssets.length) {
      setGrandSubAssetsOptions(
        getUniqueData(
          "sub_asset_1",
          grandSubAssetsOptionsCopy,
          selectedGrandSubAssets,
          currentUseCase?.id
        )
      );
    }
  }, [selectedAssets, selectedGrandSubAssets, grandSubAssetsOptionsCopy]);

  // tags - get unique options
  useEffect(() => {
    if (selectedGrandSubAssets.length) {
      setTagOptions(
        getUniqueData(
          "tags",
          tagOptionsCopy,
          selectedTagValue,
          currentUseCase?._id
        )
      );
    }
  }, [selectedGrandSubAssets, selectedTagValue, tagOptionsCopy]);

  // tags only filter - get unique options
  useEffect(() => {
    if (filteredParentAssets.length) {
      setTagFilterOptions(
        getUniqueData(
          "filter_tags",
          tagFilterOptionsCopy,
          selectedFilterTagValue,
          currentUseCase?._id
        )
      );
    }
  }, [selectedFilterTagValue, filteredParentAssets, tagFilterOptionsCopy]);

  useEffect(() => {
    const filtered = tagFilterOptions.map((option: any) => option.key);
    setTagsOnlyFilterOptions(filtered);
  }, [tagFilterOptions]);

  useEffect(() => {
    if (selectedPlant) {
      setTemplateList(
        usersList.currentUser.save_template.filter(
          (current: any) =>
            (current.type === undefined || current.type === MODULE) &&
            current.plant_id === selectedPlant?._id
        )
      );
    }
  }, [usersList, selectedPlant]);

  useEffect(() => {
    const useCase = usecaseList.usecases.find((usecase: Asset_Usecase) => {
      return usecase.routes_use_code === "utilities";
    });
    setCurrentUseCase(useCase);
    setFilterMessage({ ...filterMessage, useCaseId: useCase?._id });
    const groupArrayObject = levelsList.levels
      .filter((asset: any) => {
        return asset.use_case?.includes(useCase?._id);
      })
      .reduce((group: any, arr: any) => {
        const { plant_id } = arr;
        group[plant_id] = group[plant_id] ?? [];
        group[plant_id].push(arr);
        return group;
      }, {});

    //########################### Hard coded SL2 plant ##############################
    // setAvailablePlants(
    //   Object.keys(groupArrayObject).map((ele: any) => {
    //     return plantsList.plants.find((plant: any) => {
    //       return plant._id === ele;
    //     });
    //   })
    // );

    setAvailablePlants(
      plantsList.plants.filter((plant: any) => plant.plant_code === "SL2")
    );
    //################################################################################
  }, [usecaseList.usecases, levelsList.levels]);
  console.log("@tm availablePlants", availablePlants);
  useEffect(() => {
    if (plantsList.plants.length !== 0) {
      if (
        usersList.accessiblePlants.filter((ele: any) => {
          return ele.plant_code === defaultPlantCode;
        }).length > 0 &&
        availablePlants.filter((ele: any) => {
          return ele.plant_code === defaultPlantCode;
        }).length > 0
      ) {
        setSelectedPlant(
          plantsList.plants.find((plant: any) => {
            return plant.plant_code === defaultPlantCode;
          })
        );
      } else {
        if (
          usersList.accessiblePlants &&
          availablePlants.length > 0 &&
          usersList.accessiblePlants.filter((accessibePlant: any) => {
            return availablePlants
              .map((plant: any) => {
                return plant._id;
              })
              .includes(accessibePlant._id);
          }).length > 0
        ) {
          setSelectedPlant(
            usersList.accessiblePlants.filter((accessibePlant: any) => {
              return availablePlants
                .map((plant: any) => {
                  return plant._id;
                })
                .includes(accessibePlant._id);
            })[0]
          );
          //setting plant code for cube fetching of access token
          appContextProps.setSelectedPlantForCube(
            usersList.accessiblePlants.filter((accessibePlant: any) => {
              return availablePlants
                .map((plant: any) => {
                  return plant._id;
                })
                .includes(accessibePlant._id);
            })[0]?.plant_code
          );
        }
      }
    }
  }, [plantsList.plants, availablePlants]);

  useEffect(() => {
    if (selectedPlant !== null) {
      setFilterMessage({ ...filterMessage, plantId: selectedPlant?._id });
      appContextProps.setSelectedPlantForCube(selectedPlant?.plant_code);
      setDateRangeValue([
        new Date(
          momentTz()
            .subtract(24, "hours")
            .tz(selectedPlant?.plant_timezone)
            ?.format("YYYY-MM-DDTHH:mm:ss.SSS")
        ),
        new Date(
          momentTz()
            .tz(selectedPlant?.plant_timezone)
            ?.format("YYYY-MM-DDTHH:mm:ss.SSS")
        ),
      ]);

      handleDataRanges();
    }
  }, [selectedPlant]);

  useEffect(() => {
    if (assetData?.length > 0) {
      if (queryKeyString === "get_parent_asset") {
        setFilteredParentAssets(assetData);
      }
    }
    if (queryKeyString === "get_sub_asset") {
      setFilteredAssets(assetData);
    }
    if (queryKeyString === "get_sub_asset_1") {
      const childOptions: any = extractGrandChildOptions(assetData);
      setGrandSubAssetsOptions(childOptions);
      setGrandSubAssetsOptionsCopy(childOptions);
    }
    if (queryKeyString === "get_asset_for_tag_filter") {
      setAssetsForTagsFilter(assetData);
    }
  }, [assetData]);

  useEffect(() => {
    if (
      selectedPlant &&
      currentUseCase &&
      levelTypes &&
      levelsList &&
      assetIds.length === 0
    ) {
      //Extract parent assets dor assets filter
      const level0 = levelTypes.find(
        (level: any) => level?.level_types_code === "L0"
      )?._id;
      const assetsData = levelsList.levels.filter((asset: any) => {
        return (
          asset.use_case?.includes(currentUseCase?._id) &&
          asset?.plant_id === selectedPlant?._id &&
          asset?.level === level0
        );
      });
      setQueryKeyString("get_parent_asset");
      setAssetData(assetsData);
      setSelectedFilterTagValue([]);
      setAssetsForTagsFilter([]);
    }
  }, [selectedPlant, currentUseCase, assetsList, levelsList]);

  useEffect(() => {
    // Extract base tags for tags only filter
    const level2 = levelTypes.find(
      (level: any) => level?.level_types_code === "L2"
    )?._id;
    const grandSubAssetsForTagsFilter = levelsList.levels
      .filter((asset: any) => {
        return (
          asset.use_case?.includes(currentUseCase?._id) &&
          asset?.plant_id === selectedPlant?._id &&
          asset?.level === level2
        );
      })
      .map((asset: any) => {
        if (asset?.devices?.length > 0) {
          return asset?.devices?.find(
            (device: any) => device?.usecase === currentUseCase?._id
          )?.tag;
        }
      });
    if (grandSubAssetsForTagsFilter?.length > 0) {
      getTagsForTagsFilter({
        tagsCube,
        cubejsApi,
        setTagFilterOptions,
        setTagFilterOptionsCopy,
        assetsForTagsFilter: grandSubAssetsForTagsFilter,
      });
    }
  }, [
    selectedPlant,
    currentUseCase,
    assetsList,
    levelsList,
    cubejsApi,
    tagsCube,
  ]);

  useEffect(() => {
    if (
      filterMessage?.useCaseId !== "" &&
      filterMessage?.useCaseId !== undefined &&
      filterMessage?.plantId !== "" &&
      filterMessage?.plantId !== undefined &&
      parentAssetOptions?.length
    ) {
      const parentAssetIds = selectedParentAssets.map((item: any) => item?.id);
      if (parentAssetIds.length) {
        if (JSON.stringify(selectedParentAssets) !== selectedParentAssetsCopy) {
          const assetsData = levelsList.levels.filter((asset: any) => {
            return (
              asset.use_case?.includes(currentUseCase?._id) &&
              asset?.plant_id === selectedPlant?._id &&
              parentAssetIds.includes(asset?.parent_asset)
            );
          });
          setQueryKeyString("get_sub_asset");
          setAssetData(assetsData);
          setSelectedParentAssetsCopy(JSON.stringify(selectedParentAssets));
        }
      } else {
        setSelectedParentAssetsCopy("");
      }
    }
  }, [selectedParentAssets, parentAssetOptions, tagFilterOptions]);

  useEffect(() => {
    const parentAssetIds = selectedAssets.map((item: any) => item?.id);
    if (parentAssetIds.length && assetOptions.length) {
      if (JSON.stringify(selectedAssets) !== selectedAssetsCopy) {
        const assetsData = levelsList.levels.filter((asset: any) => {
          return (
            asset.use_case?.includes(currentUseCase?._id) &&
            asset?.plant_id === selectedPlant?._id &&
            parentAssetIds.includes(asset?.parent_asset)
          );
        });
        setQueryKeyString("get_sub_asset_1");
        setAssetData(assetsData);
        setSelectedAssetsCopy(JSON.stringify(selectedAssets));
      }
    } else {
      setSelectedAssetsCopy("");
    }
  }, [selectedAssets, assetOptions]);

  useEffect(() => {
    if (
      grandSubAssetsOptions?.length &&
      !assetsForTagsFilter?.length &&
      JSON.stringify(grandSubAssetsOptions) !== grandSubAssetsOptionsCopy
    ) {
      const grandAssetsTagsForTagsFilter = grandSubAssetsOptions.map(
        (item: any) => item?.tag
      );
      setQueryKeyString("get_asset_for_tag_filter");
      setAssetData(grandAssetsTagsForTagsFilter);
    }
  }, [
    grandSubAssetsOptions,
    filterMessage,
    cubejsApi,
    tagsCube,
    assetsForTagsFilter,
    selectedPlant,
  ]);

  useEffect(() => {
    if (assetOptions.length) {
      if (JSON.stringify(selectedAssets) !== selectedAssetsCopy) {
        setSelectedAssetsCopy(JSON.stringify(selectedAssets));
      }
    } else {
      setSelectedAssetsCopy("");
    }
  }, [selectedAssets, assetOptions]);

  useEffect(() => {
    if (
      metaCubeNames &&
      metaCubeNames.response &&
      metaCubeNames.response.cubes.length > 0 &&
      selectedPlant !== null &&
      levelsList.levels.length !== 0 &&
      usecaseList.usecases.length !== 0
    ) {
      //use effect for handling change in plant
      setTagsCube(
        metaCubeNames.response.cubes.find((cube: any) => {
          return cube.name === "Tags";
        })
      );
    }
  }, [
    usecaseList.usecases,
    levelsList.levels,
    selectedPlant,
    metaCubeNames.response,
  ]);

  // useEffect(() => {
  //   //use effect for fetching tags master list once plant is selected
  //   if (selectedPlant !== null) {
  //     if (correspondingCubes?.length > 0) {
  //       selectedAssets.length && getTags();
  //       localStorage.setItem(
  //         "correspondingCubes",
  //         JSON.stringify(correspondingCubes)
  //       );
  //     }
  //   }
  // }, [correspondingCubes]);

  useEffect(() => {
    const grandSubAssetsTags: any = [];
    selectedGrandSubAssets?.forEach((item: any) => {
      if (item?.tag !== "") {
        grandSubAssetsTags.push(item?.tag);
      }
    });
    const extractedTagOptions = extractTagOptions(
      selectedGrandSubAssets.length > 0
        ? [...tagsArray1, ...grandSubAssetsTags]
        : []
    );
    setTagOptions(extractedTagOptions);
    setTagOptionsCopy(extractedTagOptions);
  }, [selectedAssets, selectedGrandSubAssets, tagsArray1]);

  // fetch tags
  useEffect(() => {
    selectedGrandSubAssets.length && getTags();
  }, [selectedGrandSubAssets]);

  useEffect(() => {
    getData();
  }, [
    selectedTagValue,
    dateRangeValue,
    selectedTemplateObj,
    selectedFilterTagValue,
    selectedInterval,
  ]);

  useEffect(() => {
    handleDateChange(dateRangeValue);
  }, [tabValue]);

  useEffect(() => {
    const invalidTagsCollection: any = [];
    if (
      Object.keys(groupResponse).length > 1 &&
      (tabValue === 1 || tabValue === 2 || tabValue === 3)
    ) {
      Object.keys(groupResponse)?.map((item: any) => {
        if (
          groupResponse[Object.keys(groupResponse)[0]]?.length !==
          groupResponse[item]?.length
        ) {
          invalidTagsCollection.push(item);
        }
      });
      selectedTagValueCountMismatch.flag = true;
      selectedTagValueCountMismatch.invalid_tag = invalidTagsCollection;
      if (invalidTagsCollection.length > 0) {
        dispatch({
          type: "LOAD_SNACKBAR",
          payload: {
            message: "Plotting failed for few tags due to inconsistent data.",
            type: "warning",
            open: true,
          },
        });
      }
    }
    if (tabValue === 0 || Object.keys(groupResponse).length <= 1) {
      selectedTagValueCountMismatch.flag = false;
      selectedTagValueCountMismatch.invalid_tag = [];
    }
  }, [groupResponse, tabValue, dispatch]);

  useEffect(() => {
    const data = async () => {
      const group_data: any = await getGroupData();
      setgroupResponse(group_data);

      const highGroup = await findHighestValueInGroup(group_data);
      setHighestGroup(highGroup);
      // Finding the max group Index
      setMaxGroupIdx(findMaxGroupIdx(group_data));
    };
    setdisableExport(cubeResponse.length === 0 ? true : false);
    data();
  }, [cubeResponse, tabValue]);

  useEffect(() => {
    setGraphViewWidth();
  }, [width]);

  useEffect(() => {
    const chartOptions1: any = {
      chart: {
        zoomType: "x",
        backgroundColor: "#232a58",
      },
      title: {
        text: "",
        style: {
          color: "#FFFFFF",
          fontFamily: "Inter",
          fontWeight: "bold",
        },
        align: "center",
      },
      credits: {
        enabled: false,
      },

      colors: colors,

      legend: {
        itemStyle: {
          color: "#FFFFFF", // Set the color of series names to white
          fontFamily: "Roboto",
          fontWeight: "normal",
        },
      },
    };
    const dateValues: any = [];
    const tagNames: any = [];
    let tagKey: any = "";
    let tagValues: any = [];
    const chartSeries: any = [];
    const copyGroupResponse: any = { ...groupResponse };
    Object.keys(copyGroupResponse).map((ele: any, index: any) => {
      if (!selectedTagValueCountMismatch.invalid_tag?.includes(ele)) {
        tagNames.push({
          gridLineWidth: 0,
          labels: {
            format: "{value}",
            style: {
              color: "#FFFFFF",
              fontFamily: "Roboto",
              fontWeight: "normal",
            },
          },
          title: {
            text: `${ele}`,
            // rotation: 0,
            // offset: index * 15,
            style: {
              color: colors[index],
              fontFamily: "Roboto",
              fontWeight: "normal",
            },
          },
          opposite: index % 2 === 0 ? false : true,
        });
        copyGroupResponse[ele]?.map((item: any) => {
          tagKey = item?.tagName.split("_")[1];
          tagValues.push(item?.value);
          if (index === maxGroupIdx) {
            const dateTime = moment(item?.date).format("MM-DD-YY hh:mm A");
            dateValues.push(dateTime); ////
          }
        });
        chartSeries.push({
          name: `${ele}`,
          type: "spline",
          // yAxis: index,
          line: {
            enabled: true, // Ensure line is always displayed
          },
          marker: {
            enabled: false, // Disable markers to always show a continuous line
            symbol: "circle",
          },
          data: [...tagValues].reverse(),
          tooltip: {
            valueSuffix: tagKey.includes("Temp")
              ? "{value}°C"
              : tagKey.includes("Press")
              ? "{value} psi"
              : "",
          },
          dataLabels: {
            style: {
              color: "#FFFFFF", // Set the color of the series name to white
              fontFamily: "Roboto",
              fontWeight: "normal",
            },
          },
        });
        tagKey = "";
        tagValues = [];
      }
    });
    chartOptions1.xAxis = [
      {
        categories: dateValues.reverse(),
        labels: {
          formatter: (object: any) => {
            return dateFormatter(object.value, plantTimeZone);
          },
          format: "{value:%m/%d %I:%M%p}",
          style: {
            color: "#FFFFFF",
            fontFamily: "Roboto",
            fontWeight: "normal",
          },
        },
        gridLineWidth: 0.5,
        gridLineDashStyle: "shortdash",
        gridLineColor: "#bbbbbb",
        crosshair: true,
        tickPixelInterval: 150,
        tickPositioner: function () {
          const { tickPositions }: any = this;
          let value = [];
          if (tickPositions.length <= 16) {
            value = tickPositions.filter((data: any, i: any) => {
              return i % 2 === 0;
            });
          } else {
            value = tickPositions.filter((data: any, i: any) => {
              return i % 4 === 0;
            });
          }
          return value;
        },
      },
    ];

    chartOptions1.yAxis = [...tagNames];
    chartOptions1.series = [...chartSeries];
    chartOptions1.tooltip = {
      backgroundColor: "#dcdee8",
      style: {
        color: "#333333",
        fontFamily: "Roboto",
        fontWeight: "normal",
      },

      shared: true, //for a particular timestamp all lines data will be shown in one tooltip
      formatter: function () {
        //   return `
        //   ${this.x} ${moment.tz('America/Los_Angeles').format("z")}
        //     <br>
        //     ${this.series.name}: ${this.y}
        //   <b>
        //  `;

        // when the tooltip is shared.
        let tooltipContent = `<b>${dateFormatter(
          this.x,
          plantTimeZone
        )} ${moment.tz(plantTimeZone).format("z")}</b><br>`;
        this.points.forEach((point: any) => {
          tooltipContent += `${point.series.name}: ${point.y.toFixed(2)}<br>`;
        });
        return tooltipContent;
      },
    };
    chartOptions1["chart"].height = 700;
    chartOptions1["chart"].spacingTop = 25;

    if (isPrint) {
      chartOptions1["chart"].width = 1100;
    }
    setChartOptionsTemp({ ...chartOptions1 });
  }, [groupResponse, isPrint, maxGroupIdx, selectedTagValueCountMismatch]);

  useEffect(() => {
    const copyGroupResponse: any = { ...groupResponse };

    const chartOptions1 = Object.keys(copyGroupResponse).map(
      (ele: any, index: any) => {
        if (!selectedTagValueCountMismatch.invalid_tag?.includes(ele)) {
          const dateValues: any = [];
          let tagKey: any = "";
          const tagValues: any = [];
          copyGroupResponse[ele]?.map((item: any) => {
            tagKey = item?.tagName.split("_")[1];
            tagValues.push(item?.value);
            const dateTime = moment(item?.date).format("MM-DD-YY hh:mm A");
            dateValues.push(dateTime);
          });

          return {
            chart: {
              marginLeft: 45,
              type: "spline",
              zoomType: "x",
              backgroundColor: "#232a58",
              height: 180,
              scrollablePlotArea: {
                minWidth: 400,
                scrollPositionX: 1,
              },
            },
            title: {
              text: `${ele}`,
              align: "left",
              style: {
                color: colors[index],
              },
            },
            series: [
              {
                name: `${ele}`,
                data: [...tagValues].reverse(),
                color: colors[index],
              },
            ],
            yAxis: {
              title: {
                text: null,
              },
              gridLineWidth: 0,
              labels: {
                enabled: false,
              },
            },
            xAxis: {
              categories: [...dateValues].reverse(),
              labels: {
                formatter: (object: any) => {
                  return dateFormatter(object.value, plantTimeZone);
                },
                format: "{value:%m/%d %I:%M%p}",
                style: {
                  color: "#fff",
                  fontFamily: "Roboto",
                  fontWeight: "normal",
                  textOverflow: "none",
                },
              },
              tickPositioner: function () {
                const { tickPositions }: any = this;
                let value = [];
                if (tickPositions.length <= 16) {
                  value = tickPositions.filter((data: any, i: any) => {
                    return i % 2 === 0;
                  });
                } else {
                  value = tickPositions.filter((data: any, i: any) => {
                    return i % 3 === 0;
                  });
                }
                return value;
              },
              crosshair: true,
            },
            tooltip: {
              backgroundColor: "#dcdee8",
              style: {
                color: "#333333",
                fontFamily: "Roboto",
                fontWeight: "normal",
              },

              shared: true,
              formatter: function (
                this: Highcharts.TooltipFormatterContextObject
              ) {
                let tooltipContent: any = ``;
                this?.points?.forEach((point: any) => {
                  tooltipContent += `<b>${dateFormatter(
                    point?.key,
                    plantTimeZone
                  )} ${moment.tz(plantTimeZone).format("z")}</b><br> ${
                    point.series.name
                  }: ${point.y.toFixed(2)}<br>`;
                });
                return tooltipContent;
              },
            },
            credits: {
              enabled: false, // This removes the Highcharts watermark
            },
          };
        }
      }
    );

    setChartOptions2([...chartOptions1]);
  }, [groupResponse, maxGroupIdx, selectedTagValueCountMismatch]);

  useEffect(() => {
    setRowsToShow(highestGroup);
  }, [highestGroup, rowsPerPage]);

  useEffect(() => {
    //Set custom column order if exist else set tag selected order.
    //when switch between table and chart view.
    customizedColumns?.length > 0
      ? setColumns(customizedColumns)
      : setColumns(Object.keys(groupResponse));
  }, [groupResponse]);

  return (
    <>
      {levelsList.loading ||
      plantsList.loading ||
      usecaseList.loading ||
      usersList.loading ? (
        <CircularProgress style={{ margin: "20% 45%" }} />
      ) : (
        <>
          <SubHeader leftSpacing={0}>
            <Grid
              container
              alignItems="center"
              justifyContent="space-between"
              sx={{ flexGrow: 1, px: 2 }}
            >
              <Grid item>
                <Button
                  id="go-back"
                  // aria-controls={open ? "basic-menu" : undefined}
                  // aria-haspopup="true"
                  // aria-expanded={open ? "true" : undefined}
                  size="large"
                  onClick={() => navigate(-1)}
                  variant="outlined"
                  fullWidth
                  endIcon={<ArrowBackIcon />}
                  sx={{
                    height: "40px", // Same height as Autocomplete
                    minWidth: "80px", // Optional, for consistent width
                  }}
                />
              </Grid>
              <Grid item>
                <Box display="flex" justifyContent="flex-end">
                  <Grid container spacing={1} justifyContent="flex-end">
                    {/* Plant Selector  */}
                    <Grid item>
                      {!isPrint ? (
                        <Autocomplete
                          // className={classes.autoCompletetSelect}
                          options={usersList.accessiblePlants.filter(
                            (accessibePlant: any) => {
                              return availablePlants
                                .map((plant: any) => {
                                  return plant?._id;
                                })
                                .includes(accessibePlant._id);
                            }
                          )}
                          getOptionLabel={(option: any) => option.plant_name}
                          value={selectedPlant}
                          onChange={(event: any, newValue: any) => {
                            setSelectedPlant(newValue);
                            appContextProps.setSelectedPlantForCube(
                              newValue.plant_code
                            );
                            resetSelectedAssetTagsTemplatesCTA();
                            setAssetIds([]);
                            setTagFilterOptions([])
                            setTagFilterOptionsCopy([])
                          }}
                          renderInput={(params: any) => (
                            <TextField
                              {...params}
                              placeholder="Select Plant"
                              size="small"
                              sx={{
                                "& .MuiInputBase-root": {
                                  height: "40px", // Set fixed height
                                  padding: "0", // Remove default padding
                                },
                                "& .MuiOutlinedInput-notchedOutline": {
                                  borderColor: "none",
                                },
                              }}
                            />
                          )}
                          fullWidth
                          style={{
                            backgroundColor: "#293368",
                            minWidth: "150px",
                            maxWidth: "250px",
                            width: "200px !important",
                            // border: '1px solid #8476EF'
                          }}
                          disableClearable
                        />
                      ) : (
                        <div className={classes.tagsConatiner}>
                          {selectedPlant?.plant_name}
                        </div>
                      )}
                    </Grid>
                    {/* Template Selector */}
                    <Grid item>
                      <Autocomplete
                        forcePopupIcon={false}
                        options={templateList}
                        getOptionLabel={(option: any) => option?.name}
                        value={selectedTemplateName}
                        onChange={(event: any, newValue: any) => {
                          handleTemplateSelect(newValue);
                        }}
                        renderInput={(params: any) => (
                          <TextField
                            {...params}
                            placeholder="Templates"
                            size="small"
                            sx={{
                              "& .MuiInputBase-root": {
                                height: "40px", // Set fixed height
                                padding: "0", // Remove default padding
                              },
                              "& .MuiOutlinedInput-notchedOutline": {
                                borderColor: "none",
                              },
                            }}
                          />
                        )}
                        disableClearable
                        fullWidth
                        style={{
                          backgroundColor: "#293368",
                          maxWidth: "250px",
                          width: "200px",
                          fontSize: "15px !important",
                          // border: '1px solid #8476EF'
                        }}
                      />
                    </Grid>
                    {selectedTemplateModified && selectedTemplateName ? (
                      <Grid item>
                        <Button
                          variant="outlined"
                          fullWidth
                          onClick={updateTemplateCTA}
                          sx={{
                            height: "40px", // Same height as Autocomplete
                            minWidth: "80px", // Optional, for consistent width
                          }}
                        >
                          Update Template
                        </Button>
                      </Grid>
                    ) : (
                      <></>
                    )}
                    {selectedTemplateName ? (
                      <Grid item>
                        <Button
                          variant="outlined"
                          fullWidth
                          onClick={handleClickOpen}
                          disabled={
                            ((selectedAssets.length === 0 ||
                              selectedTagValue.length === 0) &&
                              selectedFilterTagValue.length === 0) ||
                            !selectedTemplateModified
                          }
                          sx={{
                            height: "40px", // Same height as Autocomplete
                            minWidth: "80px", // Optional, for consistent width
                          }}
                        >
                          Save As New Template
                        </Button>
                      </Grid>
                    ) : (
                      <Grid item>
                        <Button
                          variant="outlined"
                          size="large"
                          fullWidth
                          onClick={handleClickOpen}
                          disabled={
                            (selectedAssets.length === 0 ||
                              selectedTagValue.length === 0) &&
                            selectedFilterTagValue.length === 0
                          }
                          sx={{
                            height: "40px", // Same height as Autocomplete
                            minWidth: "80px", // Optional, for consistent width
                          }}
                        >
                          Save Template
                        </Button>
                      </Grid>
                    )}
                    {selectedTemplateName ? (
                      <Grid item>
                        <Button
                          variant="outlined"
                          size="large"
                          fullWidth
                          onClick={() => {
                            setOpenDeleteConfirm(true);
                          }}
                          sx={{
                            height: "40px", // Same height as Autocomplete
                            minWidth: "80px", // Optional, for consistent width
                          }}
                        >
                          <DeleteIcon color="error" /> Delete Template
                        </Button>
                      </Grid>
                    ) : (
                      <></>
                    )}
                    <DeleteTemplate
                      open={openDeleteConfirm}
                      setOpen={setOpenDeleteConfirm}
                      selectedTemplate={selectedTemplateName}
                      handleClose={deleteTemplateCTA}
                    />
                    <Grid item>
                      <div>
                        {!exportHide ? (
                          <Button
                            disabled={disableExport}
                            id="basic-button"
                            aria-controls={open ? "basic-menu" : undefined}
                            aria-haspopup="true"
                            aria-expanded={open ? "true" : undefined}
                            onClick={handleClickExport}
                            variant="outlined"
                            fullWidth
                            endIcon={<DownIcon />}
                            sx={{
                              height: "40px", // Same height as Autocomplete
                              minWidth: "80px", // Optional, for consistent width
                            }}
                          >
                            Export
                          </Button>
                        ) : (
                          ""
                        )}
                        {!exportHide ? (
                          <Menu
                            id="basic-menu"
                            anchorEl={anchorElExport}
                            open={openExport}
                            onBlur={handleCloseExport}
                            onClose={() => {
                              // handleCloseExport();
                              if (tabValue === 1) {
                                setIsPrint(false);
                                // setExportHide(false);

                                // setGraphViewWidth();
                              }
                            }}
                            MenuListProps={{
                              "aria-labelledby": "basic-button",
                            }}
                          >
                            {(tabValue === 1 || tabValue === 2) && (
                              <MenuItem
                                onClick={() => {
                                  exportPDF();
                                }}
                                sx={{
                                  height: "40px", // Same height as Autocomplete
                                  minWidth: "80px", // Optional, for consistent width
                                }}
                              >
                                <ListItemIcon>
                                  <PictureAsPdfIcon
                                    style={{ color: "white" }}
                                    fontSize="small"
                                  />
                                </ListItemIcon>
                                <ListItemText>Export PDF</ListItemText>
                              </MenuItem>
                            )}
                            {tabValue === 0 && (
                              <MenuItem
                                onClick={() => {
                                  exportCSV();
                                }}
                                sx={{
                                  height: "40px", // Same height as Autocomplete
                                  minWidth: "80px", // Optional, for consistent width
                                }}
                                // style={{ backgroundColor: "#343D70" }}
                              >
                                <ListItemIcon>
                                  <InsertDriveFileIcon
                                    style={{ color: "white" }}
                                    fontSize="small"
                                  />
                                </ListItemIcon>
                                <ListItemText>Export Excel</ListItemText>
                              </MenuItem>
                            )}
                          </Menu>
                        ) : (
                          ""
                        )}
                      </div>
                    </Grid>
                    <Grid item></Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </SubHeader>
          <ContentSubHeader>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Card>
                  <CardHeader
                    title={cardTitle[tabValue]}
                    subheader={cardSubTitle[tabValue]}
                    action={
                      <Grid container spacing={1} justifyContent="flex-end">
                        <Grid item>
                          <Button
                            variant="contained"
                            size="large"
                            fullWidth
                            onClick={handleMetricOpenDialog}
                            endIcon={<AddIcon />}
                            sx={{
                              height: "46px", // Same height as Autocomplete
                              minWidth: "80px", // Optional, for consistent width
                            }}
                          >
                            Add Metric
                          </Button>
                        </Grid>
                        <Grid item>
                          {!isPrint ? (
                            <CustomProvider theme="dark">
                              <DateRangePicker
                                ranges={dataRanges}
                                className={classes.datePickerBox}
                                value={dateRangeValue}
                                onChange={handleDateChange}
                                showMeridian
                                size="sm"
                                format="MM-dd-yy - HH:mm"
                                placeholder="MM/DD/YY - HH:MM to MM/DD/YY - HH:MM"
                                // defaultCalendarValue={[
                                //   new Date(value).setHours("0:0:0:0"),
                                //   new Date(value),
                                // ]}
                                // showOneCalendar
                                color="red"
                                style={{
                                  height: "46px",
                                }}
                              />
                            </CustomProvider>
                          ) : (
                            <div className={classes.tagsConatiner}>
                              Date Range:{" "}
                              {`${moment(dateRangeValue[0]).format(
                                "MM-DD-YY - HH:mm"
                              )}-
             						${moment(dateRangeValue[1]).format("MM-DD-YY - HH:mm")}`}
                            </div>
                          )}
                        </Grid>
                        <Grid item className={classes.fliterMenus}>
                          {!isPrint ? (
                            <Tabs
                              value={tabValue}
                              onChange={handleChange}
                              aria-label="basic tabs example"
                            >
                              <Tab
                                label={<ListIcon />}
                                {...a11yProps(0)}
                                sx={{
                                  height: "40px", // Same height as Autocomplete
                                  minWidth: "80px", // Optional, for consistent width
                                }}
                              />
                              <Tab
                                label={<ChartIcon />}
                                {...a11yProps(1)}
                                sx={{
                                  height: "40px", // Same height as Autocomplete
                                  minWidth: "80px", // Optional, for consistent width
                                }}
                              />
                              <Tab
                                label={<TrendAnalysisChartIcon />}
                                {...a11yProps(2)}
                                sx={{
                                  height: "40px", // Same height as Autocomplete
                                  minWidth: "80px", // Optional, for consistent width
                                }}
                              />
                            </Tabs>
                          ) : (
                            ""
                          )}
                        </Grid>
                        <Grid item>
                          {!isPrint && (
                            <a
                              href={`https://niagarawater1.sharepoint.com/sites/mfg/SitePages/${selectedPlant?.plant_code.toUpperCase()}-Plant.aspx`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <Button
                                variant="outlined"
                                size="large"
                                fullWidth
                                startIcon={<DocumentIcon />}
                                sx={{
                                  height: "46px",
                                  minWidth: "80px",
                                }}
                                disabled={true}
                              >
                                Documentation
                              </Button>
                            </a>
                          )}
                        </Grid>
                      </Grid>
                    }
                  />
                  <CardContent sx={{ p: 0, minHeight: "600px" }}>
                    {!isPrint &&
                    (selectedTagValue.length > 0 ||
                      selectedFilterTagValue.length > 0) ? (
                      <Box sx={{ p: 2, backgroundColor: "#171d3f" }}>
                        <Typography variant="h6">Selected Metric: </Typography>
                        {/* <Stack direction='column' spacing={1}> */}
                        <Grid container spacing={1}>
                          {[...selectedTagValue, ...selectedFilterTagValue]
                            ?.filter(
                              (item: any, index: number, self: any) =>
                                index ===
                                self.findIndex(
                                  (t: any) => t.label === item.label
                                )
                            )
                            .map((item: any, index: number) => (
                              <Grid item xs={6} sm={3} md={2} lg={2}>
                                <Chip label={item.value} variant="outlined" />
                              </Grid>
                            ))}
                        </Grid>
                        {/* </Stack> */}
                      </Box>
                    ) : (
                      ""
                    )}

                    <Box className={classes.criticalControlSec}>
                      <Grid
                        container
                        direction="row"
                        justifyContent="between"
                        alignItems="left"
                        spacing={2}
                        rowSpacing={4}
                      >
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={12}
                          sx={{
                            padding: "0px", // Same height as Autocomplete
                          }}
                        >
                          {isLoading ? (
                            <Grid
                              container
                              sx={{
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <CircularProgress />
                            </Grid>
                          ) : columns.length > 0 &&
                            (selectedTagValue.length > 0 ||
                              selectedFilterTagValue.length > 0) ? (
                            <Grid>
                              <CustomTabPanel value={tabValue} index={0}>
                                <TableContainer
                                  sx={{
                                    padding: "0px", // Same height as Autocomplete
                                  }}
                                >
                                  <Table>
                                    <TableHead>
                                      <TableRow>
                                        <StyledTableCell
                                          className={
                                            classes.tableHeadTypography
                                          }
                                        >
                                          Date
                                        </StyledTableCell>
                                        <StyledTableCell
                                          className={
                                            classes.tableHeadTypography
                                          }
                                        >
                                          Time
                                        </StyledTableCell>
                                        {columns.map((column, index) => (
                                          <Tooltip title={column}>
                                            <StyledTableCell
                                              //key={column.id}
                                              draggable
                                              onDragStart={(e) =>
                                                handleDragStart(e, index)
                                              }
                                              onDragOver={handleDragOver}
                                              onDrop={(e) =>
                                                handleDrop(e, index)
                                              }
                                              className={
                                                classes.tableHeadTypography
                                              }
                                              title=""
                                              // align={column.align}
                                              // style={{ minWidth: column.minWidth }}
                                            >
                                              {column}
                                            </StyledTableCell>
                                          </Tooltip>
                                        ))}
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {rowsToShow
                                        ?.slice(
                                          page * rowsPerPage,
                                          page * rowsPerPage + rowsPerPage
                                        )
                                        ?.map((rowData: any, rowIndex: any) => {
                                          const dataIndex =
                                            page * rowsPerPage + rowIndex; // Calculate adjusted index
                                          return (
                                            <TableRow
                                              key={dataIndex}
                                              className={`${
                                                rowIndex % 2 === 0
                                                  ? classes.tableRow1
                                                  : classes.tableRow2
                                              }`}
                                            >
                                              <TableCell
                                                className={
                                                  classes.tableBodyCell
                                                }
                                              >
                                                <Typography
                                                  variant="body1"
                                                  noWrap
                                                >
                                                  {convertTimezoneCustom(
                                                    rowData?.date,
                                                    "America/Los_Angeles",
                                                    plantTimeZone,
                                                    "MMM DD, YYYY"
                                                  )}
                                                </Typography>
                                              </TableCell>
                                              <TableCell
                                                className={
                                                  classes.tableBodyCell
                                                }
                                              >
                                                <Typography
                                                  variant="body1"
                                                  noWrap
                                                >
                                                  {convertTimezoneCustom(
                                                    rowData?.date,
                                                    "America/Los_Angeles",
                                                    plantTimeZone,
                                                    "hh:mm A z"
                                                  )}
                                                </Typography>
                                              </TableCell>

                                              {columns.map(
                                                (columnName: string) => {
                                                  return (
                                                    <TableCell
                                                      key={columnName}
                                                      className={
                                                        classes.tableBodyCell
                                                      }
                                                    >
                                                      {groupResponse[
                                                        columnName
                                                      ]?.[dataIndex] ? (
                                                        <Typography
                                                          variant="body1"
                                                          noWrap
                                                        >
                                                          {Number(
                                                            groupResponse[
                                                              columnName
                                                            ][dataIndex].value
                                                          ).toFixed(2)}
                                                        </Typography>
                                                      ) : (
                                                        <Typography
                                                          variant="body1"
                                                          noWrap
                                                        >
                                                          No Data
                                                        </Typography>
                                                      )}
                                                    </TableCell>
                                                  );
                                                }
                                              )}
                                            </TableRow>
                                          );
                                        })}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                                <Box p={2}>
                                  <TablePagination
                                    component="div"
                                    count={highestGroup?.length}
                                    page={page}
                                    rowsPerPage={rowsPerPage}
                                    rowsPerPageOptions={[5, 10, 25, 50]}
                                    onPageChange={handlePageChange}
                                    onRowsPerPageChange={handleLimitChange}
                                  />
                                </Box>
                              </CustomTabPanel>
                              <CustomTabPanel value={tabValue} index={1}>
                                <Grid
                                  ref={containerRef}
                                  xs={12}
                                  sm={12}
                                  md={12}
                                >
                                  <HighchartsReact
                                    highcharts={Highcharts}
                                    options={chartOptionsTemp}
                                    ref={chartRef}
                                  />
                                </Grid>
                              </CustomTabPanel>
                              <CustomTabPanel value={tabValue} index={2}>
                                <Grid
                                  item
                                  xs={12}
                                  sm={12}
                                  md={12}
                                  lg={12}
                                  id="simple-tabpanel-2"
                                >
                                  {cubeResponse?.length /
                                    cubeResponseTagLength >
                                  999 ? (
                                    <Grid
                                      container
                                      alignItems="center"
                                      justifyContent="center"
                                    >
                                      <Typography
                                        variant="h3"
                                        sx={{ marginTop: "250px" }}
                                      >
                                        Trend Analysis Chart can't support more
                                        than 1000 data points. Please switch to
                                        Single Chart View or Table / Reduce the
                                        selected time ranges to less than 4
                                        days.
                                      </Typography>
                                    </Grid>
                                  ) : (
                                    <TrendAnalysisChart
                                      options={chartOptions2}
                                    />
                                  )}
                                </Grid>
                              </CustomTabPanel>
                            </Grid>
                          ) : (
                            <Grid
                              container
                              alignItems="center"
                              justifyContent="center"
                            >
                              <Typography
                                variant="h3"
                                sx={{ marginTop: "250px" }}
                              >
                                No data found
                              </Typography>
                            </Grid>
                          )}
                        </Grid>
                      </Grid>

                      <Dialog
                        open={dialogOpen}
                        onClose={handleMetricCloseDialog}
                      >
                        <DialogTitle id="scroll-dialog-title">
                          <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="space-between"
                          >
                            <Box display="flex" alignItems="center">
                              <span>Utilities Metrics</span>
                            </Box>
                            <Box display="flex" justifyContent="flex-end">
                              <Grid
                                container
                                spacing={1}
                                justifyContent="flex-end"
                              >
                                <Grid item>
                                  <Button
                                    variant="outlined"
                                    size="large"
                                    fullWidth
                                    onClick={() =>
                                      setIsFilterByTags(!isFilterByTags)
                                    }
                                  >
                                    {isFilterByTags
                                      ? "Filter By Assets"
                                      : "Filter By Tags"}
                                  </Button>
                                </Grid>
                                <Grid item>
                                  <Button
                                    variant="outlined"
                                    size="large"
                                    fullWidth
                                    onClick={handleMetricCloseDialog}
                                  >
                                    Close
                                  </Button>
                                </Grid>
                              </Grid>
                            </Box>
                          </Box>
                        </DialogTitle>
                        <DialogContent
                          dividers={true}
                          style={{
                            backgroundColor: "#232a58",
                            width: "800px",
                            height: "600px",
                          }}
                        >
                          <DialogContentText id="scroll-dialog-description">
                            {!isFilterByTags ? (
                              <Grid
                                container
                                spacing={2}
                                justifyContent="flex-end"
                              >
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                  <FormControl
                                    className={classes.multiDropdown}
                                  >
                                    <InputLabel htmlFor="multi-select-label">
                                      Select Parent Assets
                                    </InputLabel>
                                    <Select
                                      isMulti
                                      onChange={handleParentAssetSelected}
                                      name="colors"
                                      options={parentAssetOptions}
                                      styles={{
                                        menu: (base) => ({
                                          ...base,
                                          zIndex: 1000,
                                        }),
                                        menuList: (base) => ({
                                          ...base,
                                          zIndex: 1000,
                                        }),
                                        multiValue: (base, { data }) => ({
                                          ...base,
                                          borderRadius: "6px",
                                          padding: "2px",
                                          margin: "2px",
                                          backgroundColor:
                                            data.color || "#000000",
                                        }),
                                        multiValueLabel: (base, { data }) => ({
                                          ...base,
                                          backgroundColor: data.color,
                                          color: "#000", // Adjust for better contrast
                                          borderRadius: "8px",
                                          fontSize: "12px",
                                        }),
                                      }}
                                      value={selectedParentAssets?.map(
                                        (item: any) => {
                                          return {
                                            value: item.label,
                                            label: item.label,
                                            key: item.key,
                                            id: item.id,
                                            color: item.color,
                                            tag: item.tag,
                                          };
                                        }
                                      )}
                                      className="basic-multi-select"
                                      classNamePrefix="select"
                                      inputId="multi-select-label"
                                      components={{
                                        Option: CustomOption,
                                        MultiValueLabel,
                                      }}
                                    />
                                  </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                  <FormControl
                                    className={classes.multiDropdown}
                                  >
                                    <InputLabel htmlFor="multi-select-label">
                                      Select Sub Assets
                                    </InputLabel>
                                    <Select
                                      isMulti
                                      onChange={assetSelected} // Handle change and update state
                                      name="colors"
                                      options={assetOptions}
                                      // Please fix this, build failed with styles
                                      styles={{
                                        menu: (base) => ({
                                          ...base,
                                          zIndex: 1000,
                                        }),
                                        menuList: (base) => ({
                                          ...base,
                                          zIndex: 1000,
                                        }),
                                        multiValue: (base, { data }) => ({
                                          ...base,
                                          borderRadius: "6px",
                                          padding: "2px",
                                          margin: "2px",
                                          backgroundColor:
                                            data.color || "#000000",
                                        }),
                                        multiValueLabel: (base, { data }) => ({
                                          ...base,
                                          backgroundColor: data.color,
                                          color: "#000", // Adjust for better contrast
                                          borderRadius: "8px",
                                          fontSize: "12px",
                                        }),
                                      }}
                                      value={selectedAssets?.map(
                                        (item: any) => {
                                          return {
                                            value: item.value,
                                            label: item.label,
                                            key: item.key,
                                            id: item.id,
                                            color: item.color,
                                            prefix: item.prefix,
                                            tag: item.tag,
                                          };
                                        }
                                      )}
                                      className="basic-multi-select"
                                      classNamePrefix="select"
                                      inputId="multi-select-label"
                                      components={{
                                        Option: CustomOption,
                                        MultiValueLabel,
                                      }}
                                    />
                                  </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                  <FormControl
                                    className={classes.multiDropdown}
                                  >
                                    <InputLabel htmlFor="multi-select-label">
                                      Select Sub Assets 2
                                    </InputLabel>
                                    <Select
                                      isMulti
                                      onChange={handleGrandSubAssets} // Handle change and update state
                                      name="sub-assets-2"
                                      options={grandSubAssetsOptions}
                                      // Please fix this, build failed with styles
                                      styles={{
                                        menu: (base) => ({
                                          ...base,
                                          zIndex: 1000,
                                        }),
                                        menuList: (base) => ({
                                          ...base,
                                          zIndex: 1000,
                                        }),
                                        multiValue: (base, { data }) => ({
                                          ...base,
                                          borderRadius: "6px",
                                          padding: "2px",
                                          margin: "2px",
                                          backgroundColor:
                                            data.color || "#000000",
                                        }),
                                        multiValueLabel: (base, { data }) => ({
                                          ...base,
                                          backgroundColor: data.color,
                                          color: "#000", // Adjust for better contrast
                                          borderRadius: "8px",
                                          fontSize: "12px",
                                        }),
                                      }}
                                      value={selectedGrandSubAssets?.map(
                                        (item: any) => {
                                          return {
                                            value: item.label,
                                            label: item.label,
                                            key: item.key,
                                            parent: item?.parent,
                                            tag: item?.tag,
                                            child: item?.child,
                                            color: item?.color,
                                            prefix: item?.prefix,
                                            id: item?.id,
                                            tagCollection: item?.tagCollection,
                                          };
                                        }
                                      )}
                                      className="basic-multi-select"
                                      classNamePrefix="select"
                                      inputId="multi-select-label"
                                      isOptionSelected={() => false}
                                      components={{
                                        Option: CustomOption,
                                        MultiValueLabel,
                                      }}
                                    />
                                  </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                  <FormControl
                                    className={classes.multiDropdown}
                                  >
                                    <InputLabel htmlFor="multi-select-tag">
                                      Select Tags
                                    </InputLabel>
                                    <Select
                                      isMulti
                                      onChange={tagSelected}
                                      name="tags"
                                      options={tagOptions}
                                      styles={{
                                        menu: (base) => ({
                                          ...base,
                                          zIndex: 1000,
                                        }),
                                        menuList: (base) => ({
                                          ...base,
                                          zIndex: 1000,
                                        }),
                                        multiValue: (base, { data }) => ({
                                          ...base,
                                          borderRadius: "6px",
                                          padding: "2px",
                                          margin: "2px",
                                          backgroundColor:
                                            data.color || "#000000",
                                        }),
                                        multiValueLabel: (base, { data }) => ({
                                          ...base,
                                          backgroundColor: data.color,
                                          color: "#000", // Adjust for better contrast
                                          borderRadius: "8px",
                                          fontSize: "12px",
                                        }),
                                      }}
                                      value={selectedTagValue
                                        ?.filter(
                                          (
                                            item: any,
                                            index: number,
                                            self: any
                                          ) =>
                                            index ===
                                            self.findIndex(
                                              (t: any) => t.key === item.key
                                            )
                                        )
                                        .map((item: any) => ({
                                          value: item.value,
                                          label: item.label,
                                          color: item.color,
                                          key: item?.key,
                                        }))}
                                      className="basic-multi-select"
                                      classNamePrefix="select"
                                      inputId="multi-select-tag"
                                      isOptionSelected={() => false}
                                      components={{
                                        Option: CustomOption,
                                        MultiValueLabel,
                                      }}
                                    />
                                  </FormControl>
                                </Grid>
                              </Grid>
                            ) : (
                              <Grid
                                container
                                spacing={2}
                                justifyContent="flex-end"
                              >
                                <Grid
                                  container
                                  spacing={2}
                                  justifyContent="flex-end"
                                >
                                  <Grid
                                    item
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    lg={12}
                                    mt={2}
                                  >
                                    <Autocomplete
                                      size="medium"
                                      multiple
                                      options={tagsOnlyFilterOptions}
                                      freeSolo
                                      value={selectedFilterTagValue.map(
                                        (obj: any) => obj?.key
                                      )}
                                      onChange={handleSelectedFilterTags}
                                      renderTags={(value, getTagProps) =>
                                        value.map((option: any, index: any) => (
                                          <Tooltip title={option}>
                                            <Chip
                                              variant="outlined"
                                              title={option}
                                              label={option}
                                              {...getTagProps({ index })}
                                            />
                                          </Tooltip>
                                        ))
                                      }
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          label="Filter Tags"
                                          value={tagsOnlyFilterInput}
                                          onChange={handleFilterInputChange}
                                          placeholder="value"
                                          fullWidth
                                        />
                                      )}
                                    />
                                  </Grid>
                                </Grid>
                              </Grid>
                            )}
                          </DialogContentText>
                        </DialogContent>
                        {/* <DialogActions>
													<Button variant='contained' size='small'>
														Add
													</Button>
												</DialogActions> */}
                      </Dialog>
                      <Dialog
                        open={open}
                        aria-labelledby="form-dialog-title"
                        maxWidth={false}
                        className={classes.bookmarkDialog}
                      >
                        <div
                          style={{
                            width: "649px",
                            padding: "28px 100px",
                            display: "flex",
                            justifyContent: "center",
                            flexDirection: "column",
                            alignItems: "center",
                          }}
                        >
                          <div className="contentWrapper">
                            <div style={{ textAlign: "center" }}>
                              <BookMarkIcon />
                              <DialogTitle>Save Template</DialogTitle>
                            </div>
                            <Typography variant="body1" component={"div"}>
                              Remember, you can access the saved template using
                              the filter option.
                            </Typography>
                          </div>
                          <div style={{ padding: "3px" }}></div>
                          <TextField
                            id="combo-box-demo"
                            sx={{ width: "100%" }}
                            onChange={(event) => {
                              handleTemplateName(event);
                            }}
                            value={templateName}
                            label="Template Name"
                          />
                          <Grid
                            item
                            md={12}
                            marginTop={"60px"}
                            className="btnFoot"
                          >
                            <Button
                              onClick={() => setOpen(false)}
                              variant="outlined"
                            >
                              Cancel
                            </Button>
                            <Button
                              disabled={
                                disable || templateName.trim().length === 0
                              }
                              onClick={() => validateTemplateName("save")}
                              className="saveBtn"
                            >
                              Save
                            </Button>
                          </Grid>
                        </div>
                      </Dialog>
                    </Box>
                  </CardContent>
                  <CardActions disableSpacing></CardActions>
                </Card>
              </Grid>
            </Grid>
          </ContentSubHeader>
        </>
      )}
    </>
  );
}

export default TroubleShoot;
